import { createFileRoute, stripSearchParams } from "@tanstack/react-router"
import type { FinancialsWindow } from "@/api/types"
import { FinancePage } from "@/components/pages/finance/page"
import {
	financialsCustomersOptions,
	financialsSeriesOptions,
	financialsSummaryOptions,
} from "@/hooks/queries/finance"
import {
	DEFAULT_FINANCIALS_WINDOW,
	DEFAULT_PAGE_SIZE,
	isFinancialsWindow,
} from "@/lib/constants"

const defaultSearch = { window: DEFAULT_FINANCIALS_WINDOW }

export const Route = createFileRoute("/_authenticated/_admin/finance")({
	validateSearch: (
		search: Record<string, unknown>,
	): { window: FinancialsWindow } => ({
		window: isFinancialsWindow(search.window)
			? search.window
			: DEFAULT_FINANCIALS_WINDOW,
	}),
	search: {
		middlewares: [stripSearchParams(defaultSearch)],
	},
	loaderDeps: ({ search }) => ({ window: search.window }),
	loader: ({ context, deps }) => {
		context.queryClient.prefetchQuery(financialsSummaryOptions(deps.window))
		context.queryClient.prefetchQuery(financialsSeriesOptions(deps.window))
		context.queryClient.prefetchQuery(
			financialsCustomersOptions({
				page: 1,
				pageSize: DEFAULT_PAGE_SIZE,
				excludeUnmapped: true,
				sortBy: "netRevenue",
				sortDesc: true,
			}),
		)
	},
	component: FinanceRoute,
})

function FinanceRoute() {
	const { window } = Route.useSearch()
	const navigate = Route.useNavigate()
	return (
		<FinancePage
			window={window}
			onWindowChange={(value) =>
				navigate({
					search: (prev) => ({ ...prev, window: value }),
					replace: true,
				})
			}
		/>
	)
}
